import actions from "./actions";

const initState = {
    readFileState: false,
    readGlobalFilesState: false,
    file: {},
    globalFiles: [],
    pagination: {},

    isFileSelectVisible: false,
    deleteFilesState: false,

    floatingViewerFile: null,
    readFloatingViewerFileState: false,
    rotateFileState: false,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.FILE_READ_FILE_REQUEST:
            return {
                ...state,
                readFileState: 'request',
            };
        case actions.FILE_READ_FILE_SUCCESS:
            return {
                ...state,
                readFileState: 'success',
                file: action.file,
            };
        case actions.FILE_READ_ALL_REQUEST:
            console.log("cookie in reducer payload:", action.payload);
            return {
                ...state,
                readGlobalFilesState: 'request',
                payload: action.payload,
            };
        case actions.FILE_READ_ALL_SUCCESS:
            return {
                ...state,
                readGlobalFilesState: 'success',

                // for infinite scroll, concat to the current files if read next page
                globalFiles: action.globalFiles,
                pagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            };
        case actions.FILE_DELETE_FILES_REQUEST:
            return {
                ...state,
                deleteFilesState: 'request',
            };
        case actions.FILE_DELETE_FILES_SUCCESS:
            return {
                ...state,
                deleteFilesState: 'success',
                deletedFileIds: action.deletedIds,
                // globalFiles: state.globalFiles.filter(f => action.deletedIds.indexOf(f.id) === -1)
            };
        case actions.FILE_TOGGLE:
            return {
                ...state,
                isFileSelectVisible: action.visible,
            };
        case actions.FILE_OPEN_FLOATING_VIEWER_REQUEST:
            return {
                ...state,
                floatingViewerFile: action.file,
                readFloatingViewerFileState: 'request',
            };
        case actions.FILE_OPEN_FLOATING_VIEWER_SUCCESS:
            return {
                ...state,
                floatingViewerFile: action.file,
                readFloatingViewerFileState: 'success',
            };
        case actions.FILE_OPEN_FLOATING_VIEWER_ERROR:
            return {
                ...state,
                readFloatingViewerFileState: 'error',
            };
        case actions.FILE_ROTATE_REQUEST:
            return {
                ...state,
                rotateFileState: 'request',
            };
        case actions.FILE_ROTATE_SUCCESS:
            return {
                ...state,
                rotateFileState: 'success',
            };
        case actions.FILE_ROTATE_ERROR:
            return {
                ...state,
                rotateFileState: 'error',
            };
        case actions.FILE_CLOSE_FLOATING_VIEWER:
            return {
                ...state,
                floatingViewerFile: null,
            };
        case actions.FILE_SET_FILE: { // Support partial update (Must have file_id)
            const globalFiles = [...state.globalFiles];
            const idx = globalFiles.findIndex(item => item.file_id === action.file.file_id);

            // Merge the file's info
            const file = {
                ...globalFiles[idx],
                ...action.file,
            };

            // Merge back to files
            globalFiles[idx] = file;

            return {
                ...state,
                globalFiles,
            };
        }
        case actions.FILE_RESET:
            return {...initState};
        default:
            return state;
    }
}
